<template>
  <div>
    <h1 class="h1 text-bold text-uppercase p-b-1 m-0">
      Contact Us
    </h1>

    <section>
      <AboutSectionHeading>
        Support
      </AboutSectionHeading>

      <div class="text-md">
        <a href="tel:1-855-723-2266" class="link d-block">
          1-855-723-2266
        </a>
        <a href="mailto:support@proreferral.com" class="link d-block">
          support@proreferral.com
        </a>
      </div>
    </section>

  </div>
</template>

<script>
import AboutSectionHeading from '../../AboutSectionHeading';

export default {
  name: 'contact-us',
  metaInfo: {
    title: 'Contact Us',
  },
  components: {
    AboutSectionHeading,
  },
};
</script>
